import _implicitStylesheets from "./image.css";
import _implicitScopedStylesheets from "./image.scoped.css?scoped=true";
import _adsIcon from "ads/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<img${"a0:src"}${"a0:alt"}${3}>`;
const stc0 = {
  "name": "loading"
};
const stc1 = {
  attrs: {
    "name": "fallback"
  },
  key: 3
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element, s: api_slot, b: api_bind, sp: api_static_part, st: api_static_fragment, h: api_element} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [$cmp.isNotLoaded ? api_slot("loading", {
    className: api_normalize_class_name($cmp.loadingClass),
    attrs: stc0,
    key: 0
  }, [api_custom_element("ads-icon", _adsIcon, {
    props: {
      "fill": $cmp.iconFill,
      "size": "custom",
      "symbol": $cmp.fallback
    },
    key: "@loading:1"
  })], $slotset) : null, !$cmp.isLoading ? api_element("div", {
    className: api_normalize_class_name($cmp.className),
    key: 2
  }, [$cmp.renderDefault ? api_slot("fallback", stc1, [api_custom_element("ads-icon", _adsIcon, {
    props: {
      "fill": $cmp.iconFill,
      "size": "custom",
      "symbol": $cmp.fallback
    },
    key: "@fallback:4"
  })], $slotset) : null, !$cmp.renderDefault ? api_static_fragment($fragment1, 6, [api_static_part(0, {
    on: {
      "load": _m2 || ($ctx._m2 = api_bind($cmp.handleLoad)),
      "error": _m3 || ($ctx._m3 = api_bind($cmp.handleError))
    },
    attrs: {
      "src": $cmp.src,
      "alt": $cmp.alt
    }
  }, null)]) : null]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["fallback", "loading"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7h4tg1fa3gk";
tmpl.legacyStylesheetToken = "undefined-_image";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
